/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * FacebookWhiteCircleIcon - Auto-generated from icon.js
 */
export const FacebookWhiteCircleIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
		<path d="M22.002 12.0622C22.002 6.50541 17.525 2.00098 12.0032 2.00098C6.47889 2.00223 2.00195 6.50541 2.00195 12.0635C2.00195 17.0841 5.659 21.2461 10.4384 22.001V14.9706H7.90122V12.0635H10.4409V9.845C10.4409 7.32406 11.9345 5.93174 14.2179 5.93174C15.3128 5.93174 16.4564 6.12796 16.4564 6.12796V8.60265H15.1953C13.9542 8.60265 13.5668 9.3788 13.5668 10.175V12.0622H16.3389L15.8965 14.9694H13.5655V21.9997C18.3449 21.2448 22.002 17.0828 22.002 12.0622Z" fill="white" />
	</svg>
);

export default FacebookWhiteCircleIcon;
